import { legacyBreakpoints } from '@carvana/merch-tailwind/breakpoints';
import { minimumMobileHeight, minimumNonMobileHeight } from '../constants';

export default function calculateSpinnerHeight(headerHeight: number) {
  const height = Math.min(
    document.documentElement.clientHeight,
    window.innerHeight
  );
  const width = Math.min(
    document.documentElement.clientWidth,
    window.innerWidth
  );
  const isMobile = width < legacyBreakpoints.m;

  return isMobile
    ? Math.max(height * 0.6, minimumMobileHeight)
    : Math.max(height - headerHeight, minimumNonMobileHeight);
}
